'use client'

import { prepareForSlot } from '@mui/base'
import { type FC } from 'react'

import { Link, type LinkProps } from 'base-ui'

import { NextLink } from '../../../next-link'

const LinkSlot = prepareForSlot(NextLink)

export const StoryblokPageListItemLink: FC<LinkProps<typeof LinkSlot>> = (
  props,
) => (
  <Link
    className="font-medium no-underline"
    color="inherit"
    slots={{
      root: LinkSlot,
    }}
    {...props}
  />
)
